import React from 'react';
import { AlertTriangleIcon, LoaderCircleIcon, RefreshCwIcon, ShieldAlertIcon } from 'lucide-react';
import { AdminBrand } from './AdminBrand';
interface AdminStatusScreenProps {
  title: string;
  message?: string | null;
  actionLabel?: string;
  onAction?: () => void;
  loading?: boolean;
  tone?: 'error' | 'warning';
  children?: React.ReactNode;
}
export function AdminStatusScreen({
  title,
  message,
  actionLabel,
  onAction,
  loading = false,
  tone = 'error',
  children
}: AdminStatusScreenProps) {
  const Icon = loading ? LoaderCircleIcon : tone === 'warning' ? ShieldAlertIcon : AlertTriangleIcon;
  return <main className="flex min-h-screen w-full items-center justify-center bg-[#07111f] px-4 py-8 text-slate-100" data-id="element-194">
      <section className="w-full max-w-md rounded-2xl border border-white/10 bg-[#0b1728] p-6 shadow-2xl shadow-black/30 sm:p-8" aria-live="polite" data-id="element-195">
        <AdminBrand data-id="element-196" />
        <div className={`mt-9 flex h-11 w-11 items-center justify-center rounded-xl ${tone === 'warning' ? 'bg-amber-400/10 text-amber-300' : 'bg-red-400/10 text-red-300'}`} data-id="element-197">
          <Icon className={`h-5 w-5 ${loading ? 'animate-spin text-cyan-300' : ''}`} data-id="element-198" />
        </div>
        <h1 className="mt-5 text-2xl font-bold text-white" data-id="element-199">{title}</h1>
        {message && <p className="mt-3 text-sm leading-6 text-slate-300" data-id="element-200">{message}</p>}
        {children}
        {onAction && actionLabel && <button type="button" onClick={onAction} className="mt-7 inline-flex min-h-11 w-full items-center justify-center gap-2 rounded-xl border border-cyan-300/30 bg-cyan-300/10 px-4 text-sm font-semibold text-cyan-100 transition-colors hover:bg-cyan-300/20 focus:outline-none focus-visible:ring-2 focus-visible:ring-cyan-300" data-id="element-201">
            <RefreshCwIcon className="h-4 w-4" data-id="element-202" />
            {actionLabel}
          </button>}
      </section>
    </main>;
}